
















import Vue from 'vue'
export default Vue.extend({
  props: {
    stepNumber: Number,
    active: Boolean,
    complete: Boolean
  },
  data () {
    return {
    }
  }
})
